import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export type PopupContentProps = {
    children: ReactNode,
};

const PopupContent = styled(({ children, ...props }: PopupContentProps) => (
    <main {...props}>
        {children}
    </main>
))`
    ${({ theme }: ThemedProperties) => css`
        height: 100%;
        margin-right: -${theme.indents.s}px;
        padding-right: ${theme.indents.s}px;

        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior-y: contain;
        
        scrollbar-gutter: stable;
        scrollbar-width: thin;
        scrollbar-color: ${theme.colors.system.deep} transparent;
        
        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }
        
        &::-webkit-scrollbar-track {
            border: none;
            border-radius: ${theme.radii.pixel.xs}px;
            background-color: ${theme.colors.system.deep};
        }
        
        &::-webkit-scrollbar-thumb {
            border: none;
            border-radius: ${theme.radii.pixel.xs}px;
            background-color: transparent;
        }
        
        &::-webkit-scrollbar-button {
            display: none;
        }
    `};
`;

PopupContent.displayName = 'PopupContent';

export { PopupContent };
